<template>
  <tg-layout>
    <template slot="header">
      <el-row type="flex" justify="space-between">
        <tg-search-tool
          @on-submit="handleSearch"
          :disabled="!searchData.search_str"
        >
          <tg-dropdown
            :items="dropdownComputed"
            @on-change="handleChange"
            trigger="click"
          >
            <template slot="icon"></template>
          </tg-dropdown>
          <tg-date-search
            ref="dateSearch"
            size="small"
            v-model="dateRange"
            oneYearLimit
          ></tg-date-search>
          <el-input
            :placeholder="$t('component.form.input.placeholder.member')"
            v-model="searchData.search_str"
            class="tg-input"
            size="small"
            style="width: 220px"
            clearable
          ></el-input>
          <template slot="right"></template>
        </tg-search-tool>
        <el-row
          type="flex"
          justify="start"
          align="middle"
          style="font-size: 14px"
        >
          <tg-button
            round
            border
            hoverBorderOnly
            theme="info"
            @click.native="handleExport"
            v-show="hasData"
          >
            <template slot="icon" slot-scope="scope">
              <i
                class="tg-icon tg-icon-export"
                :class="{ active: scope.isHover }"
              ></i>
            </template>
            {{ $t("component.btn.exportCSV") }}
          </tg-button>
        </el-row>
      </el-row>
    </template>
    <template v-if="isSearch">
      <tg-table
        ref="table"
        :columns="columns"
        :proxy="proxy"
        align="center"
        :fit="true"
        showPagination
        @on-loaded="handleLoaded"
      >
        
        <template slot="activity_target" slot-scope="scope">
          <span>{{$t('enum.target_to[' +scope.row.target_to+ ']')}}</span>
        </template>

        <template slot="activity_class" slot-scope="scope">
          <span>{{$t('enum.event_type[' +scope.row.category_id+ ']')}}</span>
        </template>

        <template slot="userfullname" slot-scope="scope">
          <tg-user-full-name
            :row="scope.row"
            :column="scope.column"
          ></tg-user-full-name>
        </template>

        <!-- 申請項目 -->
        <template slot="apply_item" slot-scope="scope">
            <span v-if="scope.row.apply_item_src">
                <template  v-for="(item) in scope.row.apply_item_src">
                    {{ $t(item) }}
                </template>
            </span>
            <span v-else>
                {{ scope.row.apply_item }}
            </span>
        </template>

        <template slot="note" slot-scope="scope">
          <span>{{ scope.row.note1 }}</span>
          <br v-if="scope.row.nonte1 != '-'" />
          <span v-if="scope.row.nonte1 != '-'">{{ scope.row.note2 }}</span>
        </template>
      </tg-table>
    </template>
    <template v-else>
      <div class="tg-bg-white">
        <tg-nodata isNeedSearch></tg-nodata>
      </div>
    </template>
  </tg-layout>
</template>

<script>
import TgLayout from "@/layout/TgLayout";
import TgDateSearch from "@/components/datePicker/TgDateSearch";
import TgUserFullName from "@/components/slot/TgUserFullName";
import TgTable from "@/components/table/TgTable";
import TgSearchTool from "@/components/tool/TgSearchTool";
import TgDropdown from "@/components/dropdown/TgDropdown";
import TgButton from "@/components/button/TgButton";
import TgNodata from "@/components/TgNodata";
import apis from "@/apis";
import { convertToRows, flatColumns } from "@/utils/table";

import xlsx from "@/utils/xlsx";
const api = apis.activity.member_search;

export default {
  components: {
    TgLayout,
    TgDateSearch,
    TgUserFullName,
    TgTable,
    TgSearchTool,
    TgDropdown,
    TgButton,
    TgNodata,
  },
  data() {
    return {
      isSearch: false,
      proxy: api.getData,
      dateRange: {},
      columns: [],
      dropdown: [], //存放活動類別之下拉選單
      total_of_member: 0,
      total_of_apply_amount: 0,
      total_of_activity: 0,
      searchData: {
        search_str: "", //查詢的會員帳號
        status: "", //查詢的活動類別
      },
      hasData: false,
    };
  },
  props: {
    hasUser: Boolean,
  },
  created() {
    if (this.$route.params.username) {
      this.$router.push({ name: "activity.member_search.index" });
    }

    this.searchData.status = "All";

    api.getColumns().then((response) => {
      this.columns = response.data.columns;
    });
  },
  computed: {
    dateString() {
      return this.dateRange.startDate + "-To-" + this.dateRange.endDate;
    },
    //按下【查詢】時將時間和其他查詢資料合併送出
    request() {
      return { ...this.searchData, ...this.dateRange };
    },
    dropdownComputed() {
      let dropdown = ["All", 0, 1, 2, 8].map((item) => {
        let key = item == 'All' ? "component.dropdown.activity.All" : "component.dropdown.activity[" + item + "]";
        return {
          name: this.$t(key),
          id: item,
        };
      });

      return this.parseDropdown(dropdown);
    },
  },
  methods: {
    handleLoaded(response) {
      this.hasData = response.data.length > 0;

      this.dateRange.startDate = response.start_date;
      this.dateRange.endDate = response.end_date;

      //活动总数
      this.total_of_activity = response.total_of_activity;
    },
    handleSearch() {
      this.isSearch = true;
      this.$nextTick(() => {
        this.$refs.table.search(this.request);
      });
    },
    handleChange(item) {
      //變更篩選類別項目
      this.selected = item;
      this.searchData.status = item.value;
    },
    handleExport() {
      let normalColumns = JSON.parse(JSON.stringify(this.columns));

      normalColumns[1].xlsx = {
        ...normalColumns[1].xlsx,
        component: TgUserFullName,
      };
      normalColumns[6].width = 250;

      let headerRow = convertToRows(normalColumns);
      let columns = flatColumns(normalColumns);

      if (this.hasData) {
        let request = { ...this.request, isExport: true };
        if (this.$route.params.username) {
          request.targetName = this.$route.params.username;
        }
        this.proxy(request).then((response) => {
          let data = response.data;
          let ws = xlsx.makeSheet(headerRow, columns, data);
          xlsx.exportExcel(
            ws,
            this.$t("menu.activity.member_search")+"-" + new Date().toISOString().replace(/[-:.]/g, "")
          );
        });
      } else {
        //使用compiledData 取得已篩選的資料
        let table = this.$refs.table.$refs.ElTable;
        let data = table.store.states.filteredData;
        let ws = xlsx.makeSheet(headerRow, columns, data);
        xlsx.exportExcel(
          ws,
          this.$t("menu.activity.member_search")+"-"+ new Date().toISOString().replace(/[-:.]/g, "")
        );
      }
    },
    parseDropdown(dropdown) {
      return dropdown.map((item) => {
        return {
          label: item.name,
          value: item.id,
        };
      });
    },
  },
};
</script>
